import React, {Component} from 'react';
import {connect} from 'react-redux';
import './App.css';
import Leads from './components/Leads'
import 'url-search-params-polyfill';
import {getAllRounds} from "../actions/PhotowallActions";
// import {trackOptin, trackSession, trackVote} from "../actions/TrackingActions";

class App extends Component {

    constructor(props) {

        super(props);

        this.state = {
            tncs: false,
            optin: false,
            codeInjected: false,
        }

    }

    resizeContainer = () => {
        const {competition: comp} = this.props;
        const {data} = comp;

        if (data) {
            const iw = window.innerWidth;
            if (data.desktopBg && iw >= 1024) {
                document.body.style.backgroundImage = `url(${data.desktopBg.file})`;
            } else if (data.tabletBg && iw < 1024 && iw >= 400) {
                document.body.style.backgroundImage = `url(${data.tabletBg.file})`;
            } else if (data.mobileBg && iw < 400) {
                document.body.style.backgroundImage = `url(${data.mobileBg.file})`;
            }
            document.title = data.name.replace(/(<([^>]+)>)/ig, ' ').trim();
            window.setTimeout(() => {
                let elHeight = document.body.scrollHeight;
                if (window.self !== window.top) {
                    window.parent.postMessage(
                        `benchvoteResize-${elHeight}`
                    );
                }
            }, 500);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.competition.dataAvailable && this.props.competition.dataAvailable) {
            this.resizeContainer();
            // this.props.dispatch(trackSession(this.props.competition.data.id, this.props.dispatch));

            // CSS FILES
            var fileref=document.createElement("link")
            fileref.setAttribute("rel", "stylesheet")
            fileref.setAttribute("type", "text/css")
            fileref.setAttribute("href", this.props.competition.data.cssContentUrl)
            if (typeof fileref!="undefined"){
                document.getElementsByTagName("head")[0].appendChild(fileref);
            }

            // FONT CSS FILES
            var fileref=document.createElement("link")
            fileref.setAttribute("rel", "stylesheet")
            fileref.setAttribute("type", "text/css")
            fileref.setAttribute("href", this.props.competition.data.fontUrl)
            if (typeof fileref!="undefined"){
                document.getElementsByTagName("head")[0].appendChild(fileref);
            }
        }
    }

    componentDidMount() {

        let hash = this.props.location.hash;
        hash = hash ? hash.replace(/(^#)/g, "") : '';
        if (hash) {
            this.props.dispatch(getAllRounds(
                hash,
                this.props.dispatch
            ));
            this.setState({hash});
        }

    }

    render() {
        return (
            <div className='content'>
                <div className='panels-cont'>
                    <div className='left-panel'>
                        <Leads />
                    </div>
                </div>
            </div>
        );
    }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {
    const prj = state.default;
    return {
        ...ownProps,
        competition: prj.competition,
        comp: prj.competition.data,
        auth: prj.auth,
        tracking: prj.tracking,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/views/App.js